<template>
  <div
    ref="legend"
    class="legend"
  >
    <div class="button-container" data-html2canvas-ignore >
      <md-button
        @click="toggleLegend"
        v-show="legends && legends.length > 0"
        ref="legendButton"
        class="md-icon-button md-raised legend-button"
        id="legendButton"
        >
        <md-icon>legend_toggle</md-icon>
        <md-tooltip md-direction="right"> Legend </md-tooltip>
      </md-button>
    </div>
    <div class="legend-container" id="legendContainer" v-show="showLegend">
      <md-tabs
        :class="{ 'hide-tabs': legends.length < 2}"
        :md-active-tab="activeTab"
        ref="legendTabs"
      >
        <md-tab
          :id="legend.blockID"
          :md-label="legend.layerName"
          :title="legend.layerName"
          v-for="legend in legends"
          :key="`legend-tab-${legend.blockID}`"
        >
          <div
            class="gradient-wrapper"
            v-if="legend && legend.type == 'gradient'"
          >
            <div>{{legend.layerName}}</div>
            <div>{{legend.values[legend.values.length - 1].label}}</div>
            <div class="gradient" :style="getGradient(legend)"></div>
            <div>{{legend.values[0].label}}</div>
          </div>
          <div
            class="list-wrapper"
            v-if="legend && legend.type == 'list'"
          >
            <div>{{legend.layerName}}</div>
            <div class="legend-value" v-for="value in legend.values" :key="`legend-value-${value.label}`">            
              <div class="legend-colour-block" :style="{ backgroundColor: value.colour }"></div>
              <div>{{value.label}}</div>
            </div>
          </div>
        </md-tab>
      </md-tabs>
    </div>
  </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
export default {
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    legends: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    activeTab: null,
    showLegend: true
  }),
  watch: {
    legends: {
      deep: true,
      handler(legends) {
        if (legends.length == 1) {
          this.activeTab = legends[0].blockID;
        }
      }
    },
  },
  methods: {
    getGradient(legend) {
      let colours = legend.values.map(el => el.colour);
      colours.reverse();
      let gradient = `background-image: linear-gradient(${colours.join(",")})`;
      return gradient;
    },
    toggleLegend() {
      this.showLegend = !this.showLegend;
      // complete jank fix for a weird vue material bug where the legend wasn't showing on strata dashboard
      // we are not sure why this is working
      this.$refs.legendTabs.contentStyles.height = "100%";
    }
  },
  mounted() {
    const legend = this.$refs.legend;
    this.map.controls[this.google.maps.ControlPosition.LEFT_CENTER].push(
      legend
    );
  }
};
</script>

<style lang="scss" scoped>
.legend {
  max-height: 35%;
  max-width: 200px;
}

.legend-container {
  margin-top: 5px;
  margin-left: 10px;
    .md-tab {
        max-height: 250px;
        padding: 10px;
        overflow: auto;
    }
}

.gradient-wrapper {
  text-align: center;
}

.gradient {
  width: 20px;
  height: 100px;
  margin: auto;
}

.legend-value {
  display: flex;
  align-items: center;
  padding: 3px 0;  
}

.legend-colour-block {
  height: 16px;
  width: 30px;
  min-width: 30px;
  margin-right: 3px;
}
</style>

<style>
.legend .md-tabs .md-tabs-navigation {
  overflow: auto;
}

.legend .md-tabs .md-tabs-navigation .md-button-content {
  overflow: hidden;
  max-width: 55px;
}

.legend .md-tabs .md-tabs-navigation .md-ripple {
  padding: 0;
}

.legend .md-tabs.hide-tabs .md-tabs-navigation {
  display: none;
}

.list-wrapper{
    overflow: auto;
}
</style>